import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manpower',
  templateUrl: './manpower.component.html',
  styleUrls: ['./manpower.component.css']
})
export class ManpowerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
